import BasePropertyView from 'BasePropertyView.js';
import Template from 'behaviors/properties/main/comment.ejs';
//=====================================================================
//
// An instance of this view represents a comment.
//
// Casey Justus, May 15, 2016
//
//=====================================================================

class MainCommentView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            'change textarea'   : 'updateAttributes',
            'blur textarea'   : 'lostFocus',
            'focus textarea'   : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  =ev.currentTarget.value || " ";
        this.model.set( propName, propVal );
    }



    render() {

        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        
        this.delegateEvents();
        return this;
    }

}

export default MainCommentView;
